<template>
  <div id="bio-material-form-modify">
    <BioMaterialRemove
      v-if="removeMaterial"
      :material-type="materialType"
      :uuid="uuid"
      :group-nid="groupNid"
      @submit-form-data="handleFormData"
      @form-error-message="handleFormError"
    />
    <BioMaterialForm
      v-else
      :group-nid="groupNid"
      :material-type="materialType"
      :uuid="uuid"
      :is-in-modal="true"
      @choose-modification="(e) => $emit('choose-modification', e)"
      @emit-step-change="emitStepChange"
      @emit-close-modal="emitCloseModal"
      @remove-material="handleRemoveMaterial"
    />
  </div>
</template>

<script>
import BioMaterialForm from "./BioMaterialForm.vue";
import BioMaterialRemove from "./BioMaterialRemove.vue";

export default {
  name: "BioMaterialStepModify",
  data() {
    return {
      removeMaterial: false,
      modifyPageData: {},
    };
  },
  components: {
    BioMaterialForm,
    BioMaterialRemove,
  },
  props: {
    groupNid: { type: String, required: true },
    materialType: { type: String, required: true },
    uuid: { type: String, required: true },
  },
  methods: {
    emitStepChange(e) {
      this.$emit("emit-step-change", e);
    },
    emitCloseModal() {
      this.$emit("emit-close-modal");
    },
    handleRemoveMaterial() {
      this.removeMaterial = true;
    },
    handleFormData(e) {
      if (e === "Canceling") {
        this.removeMaterial = false;
        this.$showNotification("info", "Returning to Modify");
      } else {
        this.$emit("handle-form-data", e);
        this.emitStepChange(4);
      }
    },
    handleFormError({ error, message, data }) {
      if (error) {
        this.$showNotification("error", error);
      } else if (message && data) {
        this.$showNotification("error", message);
      } else {
        this.$showNotification("error", "An error occurred. Please try again.");
      }
    },
  },
  mounted() {
    this.$emit("change-title", "Modify from Library Item");
  },
};
</script>

<style>
body {
  --ck-z-default: 100;
  --ck-z-modal: calc(var(--ck-z-default) + 999);
}
.ck.ck-button {
  -webkit-appearance: none;
}
</style>
